<template>
    <div @click="$emit('close')"></div>
    <dialog open>
        <header>
            <slot name="header"></slot>
        </header>
        <menu class="content-container">
            <slot name="content"></slot>
        </menu>
    </dialog>
</template>

<script>
    export default {
    };
</script>

<style scoped>
    div {
        position: fixed;
        top: 0;
        left: 0;
        height: 100vh;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        z-index: 10;
    }

    dialog {
        border: solid 1px black;
        position: fixed;
        top: 10%;
        left: 5%;
        width: 90%;
        z-index: 100;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
        padding: 0;
        margin: 0;
        overflow: hidden;
        text-align: center;
    }

    .content-container {
        background-color: white;
        height: 75%;
        font-size: 11px;
    }


    header {
        width: 100%;
        padding-top: 10px;
        padding-bottom: 5px;
        background-color: rgb(254,244,112, 0.5);
    }

        header h2 {
            margin: 0;
        }

    menu {
        padding: 0;
        margin: 0;
    }

    @media (min-width: 768px) {
        dialog {
            left: calc(5%);
            width: 90%;
            height: 80%;
        }
    }
</style>